module.exports = __webpack_public_path__ + "static/media/services.6818118e.svg";